import React from 'react';
import classNames from 'classnames';
import cls from './FinancialIndicatorsBlockDiagrams.module.css';
import { useFinancialIndicatorsBlockDiagrams } from './useFinancialIndicatorsBlockDiagrams';
import { FinancialIndicatorsDiagramLine } from '../../UI/FinancialIndicatorsDiagramLine/FinancialIndicatorsDiagramLine';
import { FinancialIndicatorsEmptyBlock } from '../../UI/FinancialIndicatorsEmptyBlock/FinancialIndicatorsEmptyBlock';

interface FinancialIndicatorsBlockDiagramsProps {
    classes?: string;
}

export const FinancialIndicatorsBlockDiagrams = ({
    classes,
}: FinancialIndicatorsBlockDiagramsProps) => {
    const { financial_info, maxValue, is_customer, is_archive } =
        useFinancialIndicatorsBlockDiagrams();

    const showEmptyBlockCustomer =
        financial_info.upcoming_period_customer_expenses === 0 &&
        financial_info.current_period_customer_expenses === 0;

    const showEmptyBlockManager =
        financial_info.upcoming_period_customer_expenses === 0 &&
        financial_info.upcoming_period_expenses === 0 &&
        financial_info.current_period_expenses === 0 &&
        financial_info.current_period_customer_expenses === 0;
    return (
        <div className={classNames(cls.FinancialIndicatorsBlockDiagrams, [classes])}>
            {showEmptyBlockCustomer || showEmptyBlockManager ? (
                is_archive ? (
                    <FinancialIndicatorsEmptyBlock isArchived={true} />
                ) : (
                    <FinancialIndicatorsEmptyBlock />
                )
            ) : (
                <>
                    <div className={cls.container}>
                        <div className={cls.Diagram}>
                            <span className={cls.DiagramTitle}>
                                {i18next.t(
                                    'FinancialIndicatorsBlockDiagrams.return.diagramTitle.current'
                                )}
                            </span>
                            <div className={cls.DiagramBlock}>
                                <FinancialIndicatorsDiagramLine
                                    //@ts-ignore
                                    value={
                                        !is_customer
                                            ? financial_info.current_period_expenses
                                            : financial_info.current_period_customer_expenses
                                    }
                                    //@ts-ignore
                                    maxCosts={maxValue}
                                    colorType={'secondary'}
                                    valueSign={financial_info.currency.sign}
                                    percent={
                                        !is_customer
                                            ? financial_info.current_period_expenses_percent
                                            : financial_info.current_period_customer_expenses_percent
                                    }
                                />
                                {!is_customer && (
                                    <FinancialIndicatorsDiagramLine
                                        //@ts-ignore
                                        value={financial_info.current_period_customer_expenses}
                                        //@ts-ignore
                                        maxCosts={maxValue}
                                        colorType={'primary'}
                                        valueSign={financial_info.currency.sign}
                                        percent={
                                            financial_info.current_period_customer_expenses_percent
                                        }
                                    />
                                )}
                            </div>
                        </div>
                        <div className={cls.Diagram}>
                            <span className={cls.DiagramTitle}>
                                {i18next.t(
                                    'FinancialIndicatorsBlockDiagrams.return.diagramTitle.future'
                                )}
                            </span>
                            <div className={cls.DiagramBlock}>
                                <FinancialIndicatorsDiagramLine
                                    value={
                                        !is_customer
                                            ? financial_info.upcoming_period_expenses
                                            : financial_info.upcoming_period_customer_expenses
                                    }
                                    //@ts-ignore
                                    maxCosts={maxValue}
                                    colorType={'secondary'}
                                    valueSign={financial_info.currency.sign}
                                    percent={
                                        !is_customer
                                            ? financial_info.upcoming_period_expenses_percent
                                            : financial_info.upcoming_period_customer_expenses_percent
                                    }
                                />
                                {!is_customer && (
                                    <FinancialIndicatorsDiagramLine
                                        //@ts-ignore
                                        value={financial_info.upcoming_period_customer_expenses}
                                        //@ts-ignore
                                        maxCosts={maxValue}
                                        colorType={'primary'}
                                        valueSign={financial_info.currency.sign}
                                        percent={
                                            financial_info.upcoming_period_customer_expenses_percent
                                        }
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
